<template>
  <div id="app">
    <router-view v-if="toggleFlag" />
  </div>
  
</template>

<script>
import {getToken} from '@/request/token'
import Cookies from 'js-cookie'
export default { 
  name: 'App',
  components: {},
  data() {
    return {
      iframeSrc: '',
      toggleFlag: true
    };
  },
  provide() {
    // 在app组件这提供一个方法
    return {
      reload: this.reload
    };
  },
  methods: {
    reload() {
      (this.toggleFlag = false),
        //等v-if重载渲染后再把值赋值回来重新再渲染
        this.$nextTick(function () {
          this.toggleFlag = true;
        });
    }
  },
  mounted() {
    if (getToken()) {
      this.$store.commit('SET_TOKEN', getToken());
    } else {
      //this.iframeSrc = 'http://192.168.1.88:9000/sso/index.html'
      //this.$store.dispatch('fedLogOut')
    }
  }
};
</script>

<style lang="scss">
* {
  margin: 0;
  padding: 0;
}

body {
  background-color: #f5f5f5;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif, 'Apple Color Emoji', 'Segoe UI Emoji', 'Segoe UI Symbol';
  line-height: 1.5;
  // min-width: 1200px !important;
}

@media screen and (min-width:600px) {
  body {
    min-width: 100% !important;
  }
}

a {
  cursor: pointer;
  text-decoration: none;
  transition: none 86ms ease-out;
}

a:hover {
  color: #2c68ff;
}

.me-area {
  background-color: #fff;
  overflow: inherit;
}

html {
  height: 100%;
}

body {
  min-height: 100%;
}

body {
  position: relative;
  overflow-y: overlay;
}

.me-pull-right {
  float: right;
}

.fl {
  float: left;
}

.fr {
  float: right;
}

.clearfix:before,
.clearfix:after {
  content: '';
  display: table;
}

ul,
ol {
  list-style: none;
}

.el-dialog__body {
  word-break: normal;
}

.el-radio__input.is-checked .el-radio__inner {
  border-color: #2c68ff;
  background: #2c68ff;
}

.el-radio__input.is-checked+.el-radio__label {
  color: #2c68ff;
}

.tl-c {
  text-align: center
}

/* .clearfix:after {
  clear: both;
}
::-webkit-scrollbar {
  height: 0;
  width: 0;
  color: transparent;
} */

</style>



// WEBPACK FOOTER //
// src/App.vue